import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onClose", "isOpen", "closeOnOverlayClick", "children", "variantProps", "dataTestId", "headerStyles", "headerContentStyles"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Flex, Grid, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay } from '@chakra-ui/react';
import { Dismiss } from '../../../../assets/icons';
import Icon from '../../../Icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function InfoModal(_ref) {
  var _otherProps$portalPro;
  var onClose = _ref.onClose,
    isOpen = _ref.isOpen,
    _ref$closeOnOverlayCl = _ref.closeOnOverlayClick,
    closeOnOverlayClick = _ref$closeOnOverlayCl === void 0 ? true : _ref$closeOnOverlayCl,
    children = _ref.children,
    variantProps = _ref.variantProps,
    dataTestId = _ref.dataTestId,
    externalHeaderStyles = _ref.headerStyles,
    externalHeaderContentStyle = _ref.headerContentStyles,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var isInContainer = !!((_otherProps$portalPro = otherProps.portalProps) !== null && _otherProps$portalPro !== void 0 && _otherProps$portalPro.containerRef);
  var prefix = dataTestId ? "".concat(dataTestId, "-") : '';
  return _jsxs(Modal, _objectSpread(_objectSpread({
    "data-testid": "".concat(prefix, "ChakraModal"),
    scrollBehavior: "inside",
    isCentered: true,
    isOpen: isOpen,
    onClose: onClose,
    closeOnOverlayClick: closeOnOverlayClick
  }, otherProps), {}, {
    children: [_jsx(ModalOverlay, _objectSpread({}, isInContainer && {
      width: '100%',
      height: '100%'
    })), _jsxs(ModalContent, _objectSpread(_objectSpread(_objectSpread({
      "data-testid": "".concat(prefix, "ModalContent")
    }, modalContentStyle(isInContainer)), {}, {
      width: otherProps.size ? 'auto' : {
        mobile: isInContainer ? 'auto' : 'full',
        sm: 'auto'
      },
      height: isInContainer ? 'fit-content' : {
        mobile: 'full',
        sm: 'auto'
      }
    }, isInContainer && {
      containerProps: {
        style: {
          width: '100%',
          height: '100%'
        }
      }
    }), {}, {
      children: [_jsx(ModalHeader, _objectSpread(_objectSpread({
        p: "lg",
        "data-testid": "".concat(prefix, "ModalHeader")
      }, externalHeaderStyles), {}, {
        children: _jsxs(Flex, {
          flexDir: "column",
          children: [_jsxs(Grid, _objectSpread(_objectSpread(_objectSpread({}, headerContentStyle), externalHeaderContentStyle), {}, {
            children: [variantProps && _jsxs(Flex, _objectSpread(_objectSpread({}, headerTitleStyle), {}, {
              "data-testid": "".concat(prefix, "ModalTitle"),
              children: [variantProps.headerIcon && _jsx(Icon, _objectSpread({
                svg: variantProps.headerIcon
              }, variantProps.externalHeaderContentStyle)), variantProps.title]
            })), _jsx(ModalCloseButton, _objectSpread(_objectSpread({
              "data-testid": "".concat(prefix, "ModalCloseButton")
            }, modalCloseButtonStyle), {}, {
              children: _jsx(Icon, {
                svg: _jsx(Dismiss, {
                  transform: "scale(1.1)"
                })
              })
            }))]
          })), (variantProps === null || variantProps === void 0 ? void 0 : variantProps.delimiter) && _jsx(Box, _objectSpread({
            "data-testid": "".concat(prefix, "Delimiter")
          }, delimiterModalStyle))]
        })
      })), _jsx(ModalBody, _objectSpread(_objectSpread({
        "data-testid": "".concat(prefix, "ModalBody")
      }, modalBodyStyle), {}, {
        children: _jsx(Box, _objectSpread(_objectSpread({
          overflowX: "hidden"
        }, modalBodyBoxStyle), {}, {
          children: children
        }))
      }))]
    }))]
  }));
}
var modalBodyStyle = {
  overflow: {
    mobile: 'hidden',
    sm: 'auto'
  },
  p: 0
};
var modalBodyBoxStyle = {
  maxHeight: {
    mobile: 'calc(96vh - 4rem)',
    sm: '66vh'
  }
};
var modalContentStyle = isInContainer => ({
  maxW: 'auto',
  maxH: 'auto',
  overflow: 'auto',
  height: {
    mobile: 'full',
    sm: 'fit-content'
  },
  my: 0,
  borderRadius: {
    mobile: isInContainer ? '0.875rem' : '0',
    sm: '0.875rem'
  },
  boxShadow: '0 0.125rem 0.75rem var(--chakra-colors-darkGrey2)',
  px: '0'
});
var headerContentStyle = {
  my: 'md',
  mx: 'sm',
  gridTemplateColumns: '1fr auto',
  alignItems: 'center'
};
var delimiterModalStyle = {
  w: 'full',
  h: '0.063rem',
  bgColor: 'lightGrey4'
};
var headerTitleStyle = {
  color: 'darkGrey1',
  justifyContent: 'flex-start',
  fontSize: 'lg',
  lineHeight: '3',
  fontFamily: 'header',
  ml: 'sm',
  padding: 0
};
var modalCloseButtonStyle = {
  h: 'var(--chakra-space-xl)',
  w: 'var(--chakra-space-xl)',
  ml: 'auto',
  position: 'static',
  _focus: {
    boxShadow: 'none'
  },
  _hover: {
    bgColor: 'transparent'
  },
  _active: {
    bgColor: 'transparent'
  }
};